import {TransportRejectionType, transportRejectionTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<TransportRejectionType>;

export const TransportRejectionTypeSelect = (props: Props) => {
  const {options = transportRejectionTypes, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
